import { DefaultPreview } from "@/main/components/shared/kogPreviewFile/previewComponents/defaultPreview";
import { getFileType, FILE_TYPES } from "./fileConfig";
import { getPreviewComponent } from "./previewComponents";

interface IKOGPreviewFileProps {
	fileExtension?: string;
	fileUrl?: string;
	showPreview?: boolean;
	guidFile?: string;
}

function KOGPreviewFile({
	fileExtension = "default",
	fileUrl,
	showPreview = true,
	guidFile,
}: Readonly<IKOGPreviewFileProps>) {
	const fileType = getFileType(fileExtension);
	const fileConfig = FILE_TYPES[fileType];

	if (!showPreview && fileType !== "image") {
		return <DefaultPreview fileType={fileType} fileExtension={fileExtension} />;
	}

	if (fileConfig.hasPreview && fileUrl) {
		const previewComponent = getPreviewComponent(fileType);

		if (previewComponent) {
			const PreviewComponent = previewComponent.component;
			return (
				<PreviewComponent
					showPreview={showPreview}
					fileUrl={fileUrl}
					fileExtension={fileExtension}
					guidFile={guidFile}
				/>
			);
		}
	}

	return <DefaultPreview fileType={fileType} fileExtension={fileExtension} />;
}

export default KOGPreviewFile;
